import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getWasabiPathWithoutTimestamp',
})
export class GetWasabiPathWithoutTimestampPipe implements PipeTransform {
  transform(wasabiPath: string): string {
    // remove timestamp with _
    return wasabiPath.replace(/_[^_]*$/, '') ?? wasabiPath;
  }
}
